export const statuses = { inProgress: "در حال پاسخگویی", expired: "پایان زمان", submitted: "ثبت شده" };
export const errorText = error => error.response?.data?.msgFa || error.response?.data?.msg || error.message;
export const dateText = value => value ? new Date(value).toLocaleString("fa-IR", { timeZone: "Asia/Tehran" }) : "—";
